import { render, staticRenderFns } from "./LKIconChat.vue?vue&type=template&id=c425d18a&"
import script from "./LKIconChat.vue?vue&type=script&lang=js&"
export * from "./LKIconChat.vue?vue&type=script&lang=js&"
import style0 from "./LKIconChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports